<div class="message-container" [class.visible]="visible()" (click)="onToastClick($event)" (dblclick)="hide()">
    <div class="toast-handle" [class.visible]="visible()"  (click)="onHandleClick($event)">
        @if (!isEmpty()) {
            <i class="fat fa-exclamation-triangle"></i>
        }
    </div>
    <div class="title-bar"><i class="far fa-xmark-square" (click)="hide()"></i> {{title()}}</div>
    <!--span *ngIf="!text" style="font-style: italic">no message yet</span-->
    <pre>{{text()}}</pre>
    <div class="toast-footer">
    </div>
</div>
